import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { DownloadIcon } from "components/common/Icons/DownloadIcon";
import { Loader } from "components/common/Icons/Loader/Loader";
import { useDownloadAll } from "./useDownloadAll";

export const DownloadAll = () => {
    const { images, handleDownloadAll, isActive, isExporting, isDownloading, downloadProgress } = useDownloadAll();
    const compressedImages = images.filter((image) => image.state === "compressed");

    return (
        <div className="flex-shrink-0 w-full h-[101px]">
            <div className="flex items-center justify-center px-6 bg-white dark:bg-darkSurface-100 border-t border-t-irGray-200 dark:border-t-darkSurface-600 h-full">
                <div
                    className={`group relative cursor-pointer flex justify-center items-center gap-4 ${
                        !isActive
                            ? "bg-irGray-600 dark:bg-darkSurface-600"
                            : "hover:bg-irBlue-400 bg-irBlue-200 dark:bg-darkPrimary-100 dark:hover:bg-darkPrimary-100"
                    } rounded-xl py-3 w-full`}
                    onClick={handleDownloadAll}
                    data-testid={`compressor-download-all-${isActive ? "active" : "inactive"}-button`}
                >
                    {isExporting ? (
                        <Loader className="stroke-white" width={25} height={25} />
                    ) : (
                        <DownloadIcon width={25} height={25} />
                    )}
                    <div className="text-white font-semibold capitalize text-[25px]">
                        {isExporting
                            ? translateFunc(`common:processing`)
                            : isDownloading
                            ? capitalize(`${translateFunc("common:downloading")} ${downloadProgress}%`)
                            : capitalize(
                                  images.length > 1
                                      ? translateFunc("common:download-all-images") || "Download All Images"
                                      : translateFunc("common:download-image"),
                              )}
                    </div>
                    <span data-compressedImageCount={compressedImages.length} />
                    {compressedImages.length > 0 && (
                        <div
                            className={`absolute -top-3 -right-3 rounded-full border-2 border-solid border-white w-7 h-7 text-white font-semibold flex items-center justify-center ${
                                !isActive
                                    ? "bg-irGray-600 dark:bg-darkSurface-600"
                                    : "bg-irBlue-200 dark:bg-darkPrimary-100"
                            }`}
                            data-testid={`compressor-download-all-downloadable-images-count`}
                        >
                            {compressedImages.length}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
